import React, { PropsWithChildren } from 'react';

import * as S from './ModalPadding.style';

export const ModalPadding: React.FC<PropsWithChildren> = ({ children }) => {
  return <S.Container>{children}</S.Container>;
};
